import React, { memo } from 'react';
import "./ModalFormTemplate.css";
import { Form, Formik } from 'formik';
import { ModalTemplate } from '../modals/ModalTemplate';
import { useTranslation } from 'react-i18next';

export const ModalFormTemplate = memo(({ title, show, setShowForm, onSaveData, validationSchema, initialValues, children, handleCloseForm }) => {
    const { i18n: { t } } = useTranslation();
  return (
    <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSaveData}
    >
        {
            (formikProps) => (
                <ModalTemplate
                    title={title}
                    show={show}
                    setShowForm={setShowForm}
                    handleCloseForm={!!handleCloseForm ? () => handleCloseForm(formikProps): undefined}
                >
                    <Form>
                        { children({ ...formikProps }) }

                        <button disabled={formikProps.isSubmitting} type='submit' className='btn btn-home-start confirm-client-form-button'>
                            <div className='button-shadow'></div>
                            { t('App.save') }
                        </button>
                    </Form>
                </ModalTemplate>
            )
        }
    </Formik>
  )
}
)
